// src/hooks/useUserContext.ts
import { useContext } from 'react';
import { UserContext } from '@/components/Contexts/UserContext';
import {IUser} from '@/model/IUser.ts';

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

export function useUser(): IUser | undefined {
  const context = useUserContext();
  if (!context) {
    throw new Error('useUser deve ser utilizado dentro de um UserProvider');
  }
  return context.user;
}
